// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "serviceCard-3Fs_S";
var _4 = "description-36gAY";
var _5 = "buttons-OoIOV";
var _6 = "active-2GEcY";
var _7 = "header-1Yj5A";
var _8 = "headerText-37w3c";
var _9 = "confirm-5s5k1";
var _a = "headerPrice-2UKQW";
var _b = "footer-gGC2D";
var _c = "footerControls-xW-mj";
export { _1 as "__esModule", _2 as "mobile", _3 as "serviceCard", _4 as "description", _5 as "buttons", _6 as "active", _7 as "header", _8 as "headerText", _9 as "confirm", _a as "headerPrice", _b as "footer", _c as "footerControls" }
export default { "__esModule": _1, "mobile": _2, "serviceCard": _3, "description": _4, "buttons": _5, "active": _6, "header": _7, "headerText": _8, "confirm": _9, "headerPrice": _a, "footer": _b, "footerControls": _c }
